import { BaseRoleplayer, ClientType } from '../../common/types/client';
import { JSX } from 'react';
import ClientStatusBadge from './clientStatusBadge';
import PageHeaderSummary from '../../common/components/pageHeaderSummary';

interface ClientPageHeaderSummaryProps {
  /**
   * Client details
   */
  client: BaseRoleplayer;
  /**
   * Page header title
   * @default clientName
   */
  title?: string;
}

/**
 * Summary page header for the Client pages
 */
const ClientPageHeaderSummary = ({
  client,
  title = client.roleplayerName,
}: ClientPageHeaderSummaryProps): JSX.Element => {
  const summaryItems = [
    {
      title: 'Tax status',
      value: client.taxStatusNote,
    },
    {
      title: client.typeID === ClientType.Individual ? 'ID number' : 'Registration number',
      value: `${client.idNumber || client.regNumber}${
        client.idNumberTypeNote ? ` (${client.idNumberTypeNote})` : ''
      }`,
    },
  ];

  return (
    <PageHeaderSummary
      title={title}
      titleAction={<ClientStatusBadge client={client} size={20} />}
      items={summaryItems}
    />
  );
};

export default ClientPageHeaderSummary;
